module.exports = "<div style=\"text-align:center\">\n  <h1>\n    BubbleDown coming soon...\n  </h1>  \n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// D:/WebSites/BubbleDown/bubbledown-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main